import React, { Component } from "react";
import Cards from "./adminCard";
import Pagination from "react-bootstrap/Pagination";
import axios from "axios";
import App from "../../App";
import Home from "../home";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import { connect } from "react-redux";

let source = axios.CancelToken.source();

//visitor component for admin panel which is the first page to be displayed, we store vistor details by doing an axios call and storing them in the state
class AdminVisitors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataloading: false,
      currentPageNumber: 1,
      visitorData: {
        visitorDataObjectArray: [],
        pageCount: 1,
        total_pages: 1,
        count: 0,
      },
    };
    source = axios.CancelToken.source();
    this._isMounted = false;
  }

  toastMessagePopUp = (message) => {
    // toast error popup message
    toast.error(message, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  visitorDataLoading = () => {
    // function to get visitor for museum it takes page number as a parameter
    this._isMounted = true;
    if (this._isMounted) {
      this.setState({ dataloading: true });
    }
    let id = this.props.user.museum_id;
    const pageNumber = this.state.currentPageNumber;
    const jsonObject = {
      filters: [
        {
          name: "museum",
          op: "eq",
          val: id,
        },
      ],
    };

    let url = App.baseUrl + "api/visitor";
    axios
      .get(
        url,
        {
          params: {
            q: JSON.stringify(jsonObject),
            page: pageNumber,
            results_per_page: 5,
          },
        },
        {
          cancelToken: source.token,
        }
      )
      .then((json) => {
        let d = {
          visitorDataObjectArray: json.data.objects,
          pageCount: json.data.page,
          total_pages: json.data.total_pages,
          count: json.data.num_results,
        };
        //set visitor data to state
        if (this._isMounted) {
          this.setState({
            dataloading: false,
            visitorData: d,
            currentPageNumber: json.data.page,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          this.toastMessagePopUp(error.response.data.message);
        } else {
          this.toastMessagePopUp(
            "Something went wrong, please check your Internet connection or refresh the page"
          );
        }
        if (this._isMounted) {
          this.setState({
            dataloading: false,
          });
        }
      });
  };

  //   do a axios call here
  componentDidMount() {
    // calls visior pi after components mount
    this.visitorDataLoading();
  }

  componentWillUnmount() {
    // cleanup function perevents state from getting updated
    this._isMounted = false;
    source.cancel();
  }

  // go to any page number using this method
  gotoPage = (pageNumber) => {
    let totalPageNumber = this.state.visitorData.total_pages;
    if (pageNumber > 0 && pageNumber <= totalPageNumber) {
      this.setState({ currentPageNumber: pageNumber }, () => {
        this.visitorDataLoading();
      });
    }
  };

  // go one page forward using this method
  changePageForward = (inputPageNumber) => {
    let k = this.state.currentPageNumber;
    if (k < inputPageNumber) {
      this.setState({ currentPageNumber: ++k });
    }
  };

  // go one page backward using this method
  changePageBackward = (inputPageNumber) => {
    let k = this.state.currentPageNumber;
    if (k > 1) {
      this.setState({ currentPageNumber: --k });
    }
  };

  render() {
    // takes all the visitor data got from the get visitor api
    let dataToDisplay = [...this.state.visitorData.visitorDataObjectArray];

    // card Component which processes the admin card component and displays them when state recieves visitor data from axios call
    let cardsComponent = dataToDisplay.map((singleElement, index) => {
      return (
        <Cards
          key={index}
          name={singleElement.visitor_details.firstname}
          email={singleElement.visitor_details.email}
          phone={singleElement.visitor_details.phone_number}
          last={new Date(singleElement.updated_at).toDateString()}
        />
      );
    });

    //Pagination logic and push items in paginationItem[] and then display at paginationBasic
    let totalPageNumber = this.state.visitorData.total_pages;
    let activePage = this.state.currentPageNumber;
    let paginationBasic = null;
    let paginationItem = [];

    if (totalPageNumber > 1) {
      if (totalPageNumber === 2) {
        // if only 2 pages exists then [1][2]
        for (let number = 1; number <= 2; number++) {
          paginationItem.push(
            <Pagination.Item
              id={
                number === activePage
                  ? "pagination-active"
                  : "pagination-first-last"
              }
              key={number}
              active={number === activePage}
              onClick={this.gotoPage.bind(this, number)}
            >
              {number}
            </Pagination.Item>
          );
        }
      } else if (totalPageNumber <= 9) {
        // if total pages less than 9 then the format will be [<<][<][1][2][3][>][>>]
        if (activePage === 1) {
          // if current page is 1
          for (let number = activePage; number <= activePage + 2; number++) {
            paginationItem.push(
              <Pagination.Item
                id={
                  number === activePage
                    ? "pagination-active"
                    : "pagination-first-last"
                }
                key={number}
                active={number === activePage}
                onClick={this.gotoPage.bind(this, number)}
              >
                {number}
              </Pagination.Item>
            );
          }
        } else if (activePage === totalPageNumber) {
          // if current page equals to last page
          for (let number = activePage - 2; number <= activePage; number++) {
            paginationItem.push(
              <Pagination.Item
                id={
                  number === activePage
                    ? "pagination-active"
                    : "pagination-first-last"
                }
                key={number}
                active={number === activePage}
                onClick={this.gotoPage.bind(this, number)}
              >
                {number}
              </Pagination.Item>
            );
          }
        } else {
          for (
            let number = activePage - 1;
            number <= activePage + 1;
            number++
          ) {
            paginationItem.push(
              <Pagination.Item
                id={
                  number === activePage
                    ? "pagination-active"
                    : "pagination-first-last"
                }
                key={number}
                active={number === activePage}
                onClick={this.gotoPage.bind(this, number)}
              >
                {number}
              </Pagination.Item>
            );
          }
        }
      } else if (totalPageNumber > 9) {
        // if total pages more than 9 then the format will be [<<][<][1][2][3][4][5][>][>>]
        if (activePage === 1 || activePage === 2) {
          // if current page is first or second
          for (let number = 1; number <= activePage + 4; number++) {
            paginationItem.push(
              <Pagination.Item
                id={
                  number === activePage
                    ? "pagination-active"
                    : "pagination-first-last"
                }
                key={number}
                active={number === activePage}
                onClick={this.gotoPage.bind(this, number)}
              >
                {number}
              </Pagination.Item>
            );
          }
        } else if (
          activePage === totalPageNumber ||
          activePage === totalPageNumber - 1
        ) {
          // if current page is lastpage of lastpage-1
          for (
            let number = totalPageNumber - 4;
            number <= totalPageNumber;
            number++
          ) {
            paginationItem.push(
              <Pagination.Item
                id={
                  number === activePage
                    ? "pagination-active"
                    : "pagination-first-last"
                }
                key={number}
                active={number === activePage}
                onClick={this.gotoPage.bind(this, number)}
              >
                {number}
              </Pagination.Item>
            );
          }
        } else {
          for (
            let number = activePage - 2;
            number <= activePage + 2;
            number++
          ) {
            paginationItem.push(
              <Pagination.Item
                id={
                  number === activePage
                    ? "pagination-active"
                    : "pagination-first-last"
                }
                key={number}
                active={number === activePage}
                onClick={this.gotoPage.bind(this, number)}
              >
                {number}
              </Pagination.Item>
            );
          }
        }
        //End here
      }

      paginationBasic = (
        <Pagination>
          <Pagination.First
            id="pagination-first-last"
            onClick={this.gotoPage.bind(this, 1)}
          />
          <Pagination.Prev
            id="pagination-first-last"
            onClick={this.gotoPage.bind(this, activePage - 1)}
          />
          <Pagination.Ellipsis id="pagination-first-last" />
          {paginationItem}
          <Pagination.Ellipsis id="pagination-first-last" />
          <Pagination.Next
            id="pagination-first-last"
            onClick={this.gotoPage.bind(this, activePage + 1)}
          />
          <Pagination.Last
            id="pagination-first-last"
            onClick={this.gotoPage.bind(this, totalPageNumber)}
          />
        </Pagination>
      );
    }
    // pagination main component which process paginationItem[] and converts them into pagination items and diplays it on return()
    let totalVisitorCount = this.state.visitorData.count;

    let noVisitorComponent = (
      <div className="admin-visitor-no-visitor-text">
        <p>No visitor</p>
      </div>
    );

    return (
      // load spinner if there is no visitor data from <Spinner>
      <div className="visitors-page">
        {totalVisitorCount !== 0 ? (
          dataToDisplay.length === 0 || this.state.dataloading ? (
            <Spinner animation="border" />
          ) : (
            cardsComponent
          )
        ) : (
          noVisitorComponent
        )}
        {dataToDisplay.length !== 0 && !this.state.dataloading ? (
          <div className="page-counter">{paginationBasic}</div>
        ) : null}
        <ToastContainer
          limit={1}
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.userData.userData,
  };
};

export default connect(mapStateToProps, null)(AdminVisitors);
